const parentFormClass = 'form-flow__modes';
const waitlistClass = 'waitlist__submission';

const parentFormEl = document.querySelector(`.${parentFormClass}`);
const waitlistEls = document.querySelectorAll(`.${waitlistClass}`);

// update data attribute on the parent form element
// based on the params in the url
function updateParamsOnPageView() {
  const url = new URL(window.location.href);
  const urlParams = new URLSearchParams(url.search);
  // download-brochure is in params
  // update the attribute in the parent form element
  if (urlParams.get('download-brochure') === 'true') {
    parentFormEl?.setAttribute('data-success-action', 'download_brochure');
  } else if (urlParams.get('download-curriculum') === 'true') {
    parentFormEl?.setAttribute('data-success-action', 'download_curriculum');
  } else if (urlParams.get('download-newsletter') === 'true') {
    parentFormEl?.setAttribute('data-success-action', 'download_newsletter');
  } else if (urlParams.get('book-counselling') === 'true') {
    parentFormEl?.setAttribute('data-success-action', 'book_counselling');
  } else if (urlParams.get('prepkit-download') === 'true') {
    parentFormEl?.setAttribute('data-success-action', 'prepkit_download');
  } else if (urlParams.get('call-us-directly') === 'true') {
    parentFormEl?.setAttribute('data-success-action', 'call_us_directly');
  } else if (urlParams.get('placement-download') === 'true') {
    parentFormEl?.setAttribute('data-success-action', 'placement_download');
  } else if (urlParams.get('nset-preparation-video-button') === 'true') {
    parentFormEl?.setAttribute(
      'data-success-action', 'nset_preparation_video_button'
    );
  } else if (urlParams.get('nset-preparation-video-thumbnail') === 'true') {
    parentFormEl?.setAttribute(
      'data-success-action', 'nset_preparation_video_thumbnail'
    );
  } else if (urlParams.get('internship-report-download') === 'true') {
    parentFormEl?.setAttribute(
      'data-success-action',
      'internship_report_download',
    );
  }

  // update the intent view page
  if (urlParams.get('campus-life-page') === 'true') {
    parentFormEl?.setAttribute('data-success-view', 'campus-life');
  }
}

function initialize() {
  if (waitlistEls) {
    [...waitlistEls].forEach(waitlistEl => {
      waitlistEl.addEventListener('click', () => {
        parentFormEl?.setAttribute(
          'data-success-action', 'application_process',
        );
        const path = window.location.pathname;

        if (path.includes('campus-life')) {
          parentFormEl?.setAttribute(
            'data-success-view', 'campus-life',
          );
        }
      });
    });
  }
}

export default { initialize, updateParamsOnPageView };
